/* eslint-disable no-unused-vars */
import React from 'react'
import { useTranslation } from 'next-i18next'
import { showNotification } from 'src/core/helpers'
import { Divider, FormInstance, Row, Select } from 'antd'
import { useAppDispatch, useAppSelector } from 'src/app/hooks'
import { CustomCol, FormLabels, CustomInputNumber, CustomTag, CustomText, CustomSelect } from 'src/components'
import { isPurchaseTab, resetValidateProjectId, validateProjectId, validateProjectIdSelector } from 'src/features'

interface ProjectIdAcquisitionProps {
  emailAux: string
  form: FormInstance
  projectIdHasError: boolean
  isUserEmailInvalid: boolean
  setIsProjectRegisterModalVisible: (value: boolean) => void
}

const ProjectIdAcquisition: React.FC<ProjectIdAcquisitionProps> = (props) => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const isPurchaseTabValue = useAppSelector(isPurchaseTab)
  const { project, loading: loadingValidateProjectId } = useAppSelector(validateProjectIdSelector)


  const handleProjectToggleClick = () => {
    const isInvalidEmail = props.form.getFieldsError().some((item) => {
      return item.name[0] === 'sellerEmail' && item.errors.length > 0
    })
    if ((isInvalidEmail && !props.emailAux) || props.isUserEmailInvalid) {
      showNotification('error', t('admin.Brokerage.EmailRequired'))
    } else {
      props.setIsProjectRegisterModalVisible(true)
    }
  }

  const handleProjectIdChange = (projectId: number) => {
    if (!projectId) { dispatch(resetValidateProjectId())
    } else { dispatch(validateProjectId(projectId, true)) }
  }
  const loadingState = loadingValidateProjectId ? 'LOADING' : props.projectIdHasError ? 'PROJECT_ERROR' : project ? 'PROJECT' : null

  const projectTag = {
    LOADING: { type: 'processing', text: t('admin.Brokerage.ValidateProject') },
    PROJECT_ERROR: { type: 'error', text: t('admin.Brokerage.ProjectsError') },
    PROJECT: { type: 'success', text: project?.name },
  }[loadingState]

  return <Row>
    <CustomCol>
      <FormLabels
        title={t('admin.Brokerage.ProjectId')}
        subtitle={t('general.RequiredField')}
      />
    </CustomCol>
    <CustomCol>
      <CustomInputNumber
        placeholder={t('admin.Brokerage.ProjectIdPlaceHolder')}
        toogleText={t('admin.Brokerage.CreateProject')}
        handleToggleClick={handleProjectToggleClick}
        onChange={handleProjectIdChange}
        name={'projectId'}
        required
      />
      {(isPurchaseTabValue && projectTag) && <CustomTag type={projectTag.type} text={projectTag.text} />}

      {/* Vintage Years */}
      <br/><br/>
      {(project && project.is_vintage) && <>
        {project.vintage_items.length === 0 ? <CustomText
          type='danger' label={t('admin.Brokerage.NonActive')}
        /> : <>
          <CustomText type='secondary' label={t('admin.Brokerage.YearRequest')}/>
          <CustomSelect
            name='vintageYear'
            placeholder={t('Projects.YearPlaceholder')}
            required
          >
            {project.vintage_items.map(v => <Select.Option
              key={v.year} value={v.year}>{v.year}
            </Select.Option>)}
          </CustomSelect>
          <Divider />
        </>}
      </>}
    </CustomCol>
  </Row>
}

export default ProjectIdAcquisition
